<div class="container flex flex-col gap-3 my-3">
  <div class="text-view">
    {{ title }}
  </div>
  <div class="flex flex-wrap gap-1 font-bold w-full">
    <ng-container *ngFor="let element of listElements">
      @let mergedName = (elementTranslationBase ?? '') +
      (elementTranslationMap?.[element] ?? element);
      <lib-tag [text]="mergedName | transloco"> </lib-tag>
    </ng-container>
    @if (listElements?.length === 0) {
    <div class="italic font-normal">
      {{ "manage_location.shared.empty" | transloco }}
    </div>
    }
  </div>
  @if (hasHr) {
  <hr class="my-3" />
  }
</div>
